import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            redirect: {name: 'menu'}
        },
        {
            path: '/menu',
            name: 'menu',
            component: () => import('../views/MenuSelection')
        },
        {
            path: '/order_data',
            name: 'order_data',
            component: () => import('../views/OrderData')
        },
        {
            path: '/final_summary',
            name: 'final_summary',
            component: () => import('../views/OrderSummary')
        },
        {
            path: '/confirmation/:sessionId',
            name: 'confirm_order',
            component: () => import('../views/ConfirmOrder')
        }
    ]
})

export default router
